module.controller('listNewBankCtrl', ['$scope', '$log', '$state', '$stateParams', '$http', 'baseURI', 'OVERLAY', 'Session', function ($scope, $log, $state, $stateParams, $http, baseURI, OVERLAY, Session){
  $scope.overlay = OVERLAY['member.home.bank/add'];
  $http.get(baseURI + 'bank?Username=' + encodeURIComponent($stateParams.username), {cache: true}).then(function (resp){
    $scope.newBanks = resp.data.Data || [];
  });
}]);
